import './styles.css';

import Grid from 'components/Grid/gridv2';
import { STATISTICS_TYPES } from 'configs';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getEventResponsesForScheduler } from 'store/selectors/eventResponses';
import { getEventTypes } from 'store/selectors/eventTypes';
import { CommunityOverallScheduler, OverallStatistics } from 'types';

import { useFooterData, useGridData } from './hooks';

interface StatisticsTotalProps {
  type: STATISTICS_TYPES;
  statistic: OverallStatistics;
  overallScheduler: CommunityOverallScheduler;
  zoom: number;
  gridDataHandler: (data: any[]) => void;
}

const StatisticsTotal: FC<StatisticsTotalProps> = ({
  type,
  statistic,
  overallScheduler,
  zoom,
  gridDataHandler,
}) => {
  const { t } = useTranslation();
  const eventTypes = useSelector(getEventTypes);
  const responses = useSelector(getEventResponsesForScheduler) || [];

  const totalLabel = t('subscriptions.total');

  const getFilteredEventReplies = responses.map(({ title, color, id }) => {
    if (id === 'attended') {
      title = t('event.nomination');
    } else if (id === 'penalty') {
      title = t('event.penalty');
    }

    return {
      color,
      title: t(title),
      placement: 'statistic',
    };
  });

  const getFilteredEventTypes = eventTypes.map(({ title, color }) => {
    return {
      color,
      title,
      placement: 'statistic',
    };
  });

  const gridData = useGridData(
    statistic,
    responses,
    eventTypes,
    overallScheduler,
    type,
  );

  gridDataHandler(gridData);

  const footerData = useFooterData(
    totalLabel,
    responses,
    eventTypes,
    statistic,
    overallScheduler,
    type,
  );

  return (
    <div
      style={{
        width: '100%',
        position: 'absolute',
      }}
    >
      <div
        style={{
          width: '100%',
          height: '100%',
        }}
      >
        <Grid
          data={gridData}
          header={
            type === STATISTICS_TYPES.EVENT_REPLIES
              ? getFilteredEventReplies
              : getFilteredEventTypes
          }
          footer={footerData}
          zoom={zoom}
          statisticsTab={true}
          topHeadHeight={
            window.innerWidth > 600 ? 386 : window.innerWidth > 480 ? 351 : 334
          }
        />
      </div>
    </div>
  );
};

export default StatisticsTotal;
